import React, { Fragment } from 'react';
import { empty, showNotification } from './../../../utils';
import numeral from 'numeral';
import UthApparelUnisexForm from './UthApparelUnisexForm';

const Form = React.memo((props) => {
    if (props.apparelItem == null) {
        return null;
    }

    if (parseInt(props.apparelItem.id) === 125) {
        return (
            <UthApparelUnisexForm {...props} />
        );
    }

    const quantityOptions = [{ value: '', label: 'Select option' }];
    for (let i = 1; i <= 10; i++) {
        quantityOptions.push({ value: i, label: i });
    }

    const sizeOptions = [{ value: '', label: 'Select option' }];
    const sizesJson = JSON.parse(props.apparelItem.sizes_options_json);
    for (let i = 0; i < sizesJson.length; i++) {
        sizeOptions.push(sizesJson[i]);
    }

    const logosJson = JSON.parse(props.apparelItem.logos_options_json);
    const unitPricesJson = JSON.parse(props.apparelItem.unit_prices_json);
    const inventoryJson = JSON.parse(props.apparelItem.inventory_json);

    const validatePerson = (person, index) => {
        if (person.name === '') {
            let fieldName = 'Name';
            if (props.department.is_for_manager) {
                fieldName = 'First Name'
            }
            showNotification('Complete Information', 'Enter the ' + fieldName + ' of the person #' + (index + 1), 'info');
            return false;
        }

        if (props.department.is_for_manager && person.lastName === '') {
            showNotification('Complete Information', 'Enter the Last Name of the person #' + (index + 1), 'info');
            return false;
        }

        if (props.department.is_for_manager && person.uthId === '') {
            showNotification('Complete Information', 'Enter the UTH-ID# of the person #' + (index + 1), 'info');
            return false;
        }

        let atLeastOne = false;
        for (let i = 0; i < person.quantities.length; i++) {
            if (parseInt(person.quantities[i]) > 0) {
                atLeastOne = true;
            }
        }

        if (!atLeastOne) {
            showNotification('Complete Information', 'Select at least one shirt for the person #' + (index + 1), 'info');
            return false;
        }

        if (logosJson.length > 0 && person.logo === '') {
            showNotification('Complete Information', 'Select the Logo for the person #' + (index + 1), 'info');
            return false;
        }

        if ((parseInt(props.apparelItem.logic_version) === 1 && props.apparelItem.allow_personalization) ||
            (parseInt(props.apparelItem.logic_version) === 2 && props.personalizationEnabled)) {
            if (person.embroideryFirstLine !== undefined && person.embroideryFirstLine === '') {
                showNotification('Complete Information', 'Enter the Embroidery 1st Line for the person #' + (index + 1), 'info');
                return false;
            }
            if (person.embroiderySecondLine !== undefined && person.embroiderySecondLine === '') {
                showNotification('Complete Information', 'Enter the Embroidery 2nd Line for the person #' + (index + 1), 'info');
                return false;
            }
            if (person.embroideryEmail !== undefined && person.embroideryEmail === '') {
                showNotification('Complete Information', 'Enter the Embroidery Email for the person #' + (index + 1), 'info');
                return false;
            }
        }

        let totalQuantities = [];
        for (let j = 0; j < props.persons[0].quantities.length; j++) {
            totalQuantities.push(0);
        }

        let totalQuantity = 0;
        for (let i = 0; i < props.persons.length; i++) {
            if (props.persons[i].uthId !== person.uthId) {
                continue;
            }

            for (let j = 0; j < props.persons[i].quantities.length; j++) {
                if (parseInt(props.persons[i].quantities[j]) > 0) {
                    totalQuantity += parseInt(props.persons[i].quantities[j]);
                    totalQuantities[j] += parseInt(props.persons[i].quantities[j]);
                }
            }
        }

        if (props.apparelItem.is_clearance) {
            for (let i = 0; i < totalQuantities.length; i++) {
                if (totalQuantities[i] > 0) {
                    for (const inventory of inventoryJson) {
                        if (person.logo === undefined && inventory['combination'][0] === sizesJson[i]['value']) {
                            if (totalQuantities[i] > parseInt(inventory['inventory'])) {
                                showNotification('Not inventory', 'The inventory is not enough to complete your order', 'info');
                                return false;
                            }
                            break;
                        } else if (person.logo !== undefined && inventory['combination'][0] === sizesJson[i]['value'] && parseInt(inventory['combination'][1]) === parseInt(person.logo)) {
                            if (totalQuantities[i] > parseInt(inventory['inventory'])) {
                                showNotification('Not inventory', 'The inventory is not enough to complete your order', 'info');
                                return false;
                            }
                            break;
                        }
                    }
                }
            }
        }

        if (props.department.is_for_manager && totalQuantity > person.shirts) {
            showNotification('Complete Information', 'The person #' + (index + 1) + ' has exceeded his 5 shirts limit', 'info');
            return false;
        }

        return true;
    };

    const continueHandler = (type = 1) => {
        if (props.department.is_for_manager && props.managerClinicName === '') {
            showNotification('Complete Information', 'Enter the Manager Clinic Name', 'info');
            return false;
        }
        if (props.department.is_for_manager && props.managerName === '') {
            showNotification('Complete Information', 'Enter the Manager Name', 'info');
            return false;
        }
        if (props.department.is_for_manager && props.managerEmail === '') {
            showNotification('Complete Information', 'Enter the Manager Email', 'info');
            return false;
        }
        if (props.department.is_for_manager && props.managerAddress === '') {
            showNotification('Complete Information', 'Enter the Manager Address', 'info');
            return false;
        }
        if (props.department.is_for_manager && props.managerCity === '') {
            showNotification('Complete Information', 'Enter the Manager City', 'info');
            return false;
        }
        if (props.department.is_for_manager && props.managerState === '') {
            showNotification('Complete Information', 'Enter the Manager State', 'info');
            return false;
        }
        if (props.department.is_for_manager && props.managerZip === '') {
            showNotification('Complete Information', 'Enter the Manager Zip', 'info');
            return false;
        }
        if (props.department.is_for_manager && props.managerPhone === '') {
            showNotification('Complete Information', 'Enter the Manager Phone', 'info');
            return false;
        }

        for (let i = 0; i < props.persons.length; i++) {
            if (!validatePerson(props.persons[i], i)) {
                return;
            }
        }

        if (props.cxmlData.buyer_cookie == null) {
            props.addToCart(1, props.history, type);
        } else {
            props.addToCart(2, props.history, type);
        }
    };

    const handleSetLogo = (event) => {
        props.setLogo(event.target.value);
    };

    let buttonLabel = 'Checkout';
    if (props.addingToCart) {
        buttonLabel = <Fragment><i className="fas fa-circle-notch fa-spin" /> Adding to Cart...</Fragment>;
    }

    let saveWorkLabel = 'Save Work';
    if (props.savingWork) {
        saveWorkLabel = <Fragment><i className="fas fa-circle-notch fa-spin" /> Saving...</Fragment>;
    }

    const generatePriceColumn = (unitPrice) => {
        if (parseFloat(unitPrice) === 0) {
            return <td className="text-center">N/A</td>;
        } else {
            return <td className="text-center">{numeral(unitPrice).format('$0,0.00')}</td>;
        }
    };

    const headers = [];
    const prices = [];
    const inventories = [];
    const inventoryQuantities = [];
    for (const size of sizesJson) {
        headers.push(<th className="text-center">{size['value']}</th>);

        for (const unitPrice of unitPricesJson) {
            let unitPriceValue = unitPrice['unit_price'];
            if (parseInt(props.apparelItem.apparel_type) === 2) {   // Polo
                unitPriceValue = unitPrice['personal_unit_price'];
            }

            if (parseInt(props.apparelItem.logic_version) === 2) {
                unitPriceValue = unitPrice['total'];
            }

            if (logosJson.length === 0 && unitPrice['combination'][0] === size['value']) {
                prices.push(generatePriceColumn(unitPriceValue));
                break;
            } else if (logosJson.length > 0 && unitPrice['combination'][0] === size['value'] && parseInt(unitPrice['combination'][1]) === parseInt(props.logo)) {
                prices.push(generatePriceColumn(unitPriceValue));
                break;
            }
        }
        for (const inventory of inventoryJson) {
            if (logosJson.length === 0 && inventory['combination'][0] === size['value']) {
                inventoryQuantities.push(parseInt(inventory['inventory']));
                inventories.push(<td className="text-center">{numeral(inventory['inventory']).format('0,0')}</td>);
                break;
            } else if (logosJson.length > 0 && inventory['combination'][0] === size['value'] && parseInt(inventory['combination'][1]) === parseInt(props.logo)) {
                inventoryQuantities.push(parseInt(inventory['inventory']));
                inventories.push(<td className="text-center">{numeral(inventory['inventory']).format('0,0')}</td>);
                break;
            }
        }
    }

    const totals = [];
    for (const person of props.persons) {
        for (let i = 0; i < person.quantities.length; i++) {
            if (!totals[i]) {
                totals[i] = 0;
            }
            totals[i] += parseInt(person.quantities[i]);
        }
    }

    const totalsColumns = [];
    for (let i = 0; i < totals.length; i++) {
        totalsColumns.push(<th className="text-center">{numeral(totals[i]).format('0,0')}</th>);
    }

    if (logosJson.length > 0) {
        let hasUtp = false;
        for (let i = 0; i < logosJson.length; i++) {
            if (parseInt(logosJson[i].value) === 1) {
                hasUtp = true;
                break;
            }
        }

        let hasUth = false;
        for (let i = 0; i < logosJson.length; i++) {
            if (parseInt(logosJson[i].value) === 2) {
                hasUth = true;
                break;
            }
        }

        let utpOption = null;
        if (hasUtp) {
            utpOption = <option value="1">UT Physicians</option>;
        }

        let uthOption = null;
        if (hasUth) {
            uthOption = <option value="2">UTHealth Houston</option>;
        }

        if (props.platformType === 'uth') {
            prices.push(<th className="text-center"></th>);
        } else {
            let selectClass = 'on-hand-select';
            if ([58, 59].includes(parseInt(props.apparelItem.id))) {
                selectClass = 'on-hand-select hat-select';
            }

            prices.push(
                <th className="text-center">
                    <select value={props.logo} onChange={handleSetLogo} className={selectClass}>
                        {utpOption}
                        {uthOption}
                    </select>
                </th>
            );
        }
    }
    if (logosJson.length > 0) {
        inventories.push(<th className="text-center"></th>);
    }

    const handleAddPerson = () => {
        props.addPerson(sizesJson, logosJson);
    };

    const handleSetPersonField = (personIndex, fieldIndex, event) => {
        props.setPersonField(personIndex, fieldIndex, event.target.value);

        if (fieldIndex === 'logo') {
            if (parseInt(event.target.value) === 3) {
                props.setPersonField(personIndex, 'isUthHouston', 1);
            } else {
                props.setPersonField(personIndex, 'isUthHouston', 0);
            }
        }
    };

    const handleSetPersonQuantity = (personIndex, quantityIndex, event) => {
        props.setPersonQuantity(personIndex, quantityIndex, event.target.value);
    };

    const handleCheckShirts = (uthId, index) => {
        if (uthId !== '') {
            props.checkShirts(uthId, index)
        }
    };

    const renderPerson = (person, personIndex) => {
        let personTds = [];
        let quantitiesDisabled = false;
        if (props.department != null && props.department.is_for_manager) {
            let shirts = person.shirts == null ? 'N/A' : person.shirts;
            if (props.checkingShirts && parseInt(props.checkingShirtsIndex) === parseInt(personIndex)) {
                shirts = <i className="fas fa-circle-notch fa-spin" />;
            }

            if (person.shirts == null || parseInt(person.shirts) === 0) {
                quantitiesDisabled = true;
            }

            personTds.push(
                <td key={personIndex + '-name'} className="person-name text-left">
                    Available shirts: <span>{shirts}</span>
                </td>
            );
        } else {
            personTds.push(
                <td key={personIndex + '-name'} className="person-name">
                    <input
                        type="text"
                        value={person.name}
                        placeholder={'Enter a name'}
                        onChange={handleSetPersonField.bind(this, personIndex, 'name')}
                    />
                </td>
            );
        }

        for (let i = 0; i < person.quantities.length; i++) {
            personTds.push(
                <td key={personIndex + '-qty-' + i}>
                    <input
                        type="number"
                        disabled={quantitiesDisabled}
                        value={person.quantities[i]}
                        onChange={handleSetPersonQuantity.bind(this, personIndex, i)}
                    />
                </td>
            );
        }

        if (person.logo !== undefined && logosJson.length > 0) {
            let hasUtp = false;
            for (let i = 0; i < logosJson.length; i++) {
                if (parseInt(logosJson[i].value) === 1) {
                    hasUtp = true;
                    break;
                }
            }

            let hasUth = false;
            for (let i = 0; i < logosJson.length; i++) {
                if (parseInt(logosJson[i].value) === 2 || parseInt(logosJson[i].value) === 3) {
                    hasUth = true;
                    break;
                }
            }

            const options = [];

            if (hasUtp) {
                options.push(<option value="1">UT Physicians</option>);
            }

            if (hasUth) {
                options.push(<option value="2">UTHealth Houston</option>);
            }

            if (props.apparelItem && [22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 39, 40, 44, 45, 46, 51, 52, 53, 60, 61, 63, 64,
                65, 66, 67, 68, 69, 70, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 127, 129, 139, 140, 141, 142, 143, 144, 165, 169
            ].includes(parseInt(props.apparelItem.id))) {
                options.push(<option value="3">Heart and Vascular</option>);
                options.push(<option value="15">UTHealth Houston Children's Heart Institute</option>);
                options.push(<option value="17">UTHealth Houston Neurosciences</option>);
                options.push(<option value="18">UTHealth Houston Cizik Eye Clinic</option>);
            }

            // let cxmlEmail = '';
            // if (props.cxmlData && props.cxmlData.email) {
            //     cxmlEmail = props.cxmlData.email.toLowerCase();
            // }

            if (hasUth && props.platformType === 'uth') {
                options.push(<option value="4">Cizik School of Nursing</option>);
                options.push(<option value="5">McGovern Medical School</option>);
                options.push(<option value="6">School of Biomedical Informatics</option>);
                options.push(<option value="7">School of Dentistry</option>);
                options.push(<option value="8">School of Public Health</option>);
                // options.push(<option value="9">UTHealth Houston General</option>);
                // options.push(<option value="10">School of Public Health - Austin</option>);
                // options.push(<option value="11">School of Public Health - Brownsville</option>);
                // options.push(<option value="12">School of Public Health - Dallas</option>);
                // options.push(<option value="13">School of Public Health - El Paso</option>);
                // options.push(<option value="14">School of Public Health - San Antonio</option>);
                options.push(<option value="16">McWilliams School of Biomedical Informatics</option>);
            }

            let selectClass = '';
            if ([58, 59].includes(parseInt(props.apparelItem.id))) {
                selectClass = 'hat-select';
            }

            personTds.push(
                <td key={personIndex + '-logo'}>
                    <select value={person.logo} onChange={handleSetPersonField.bind(this, personIndex, 'logo')} className={selectClass} >
                        <option value="">Select</option>
                        {options}
                    </select>
                </td>
            );
        }

        return personTds;
    };

    const renderPersons = () => {
        return props.persons.map((person, index) => {
            let personTds = renderPerson(person, index);

            let embroideryRow = null;
            if ((parseInt(props.apparelItem.logic_version) === 1 && props.apparelItem.allow_personalization) ||
                (parseInt(props.apparelItem.logic_version) === 2 && props.personalizationEnabled)) {
                embroideryRow = (<tr className="person-row">
                    <td colSpan={personTds.length + 1} className="embroidery-row">
                        <input
                            type="text"
                            className="personzalization-input"
                            maxLength="40"
                            value={person.embroideryFirstLine}
                            onChange={handleSetPersonField.bind(this, index, 'embroideryFirstLine')}
                            placeholder={'1st Line: Enter your name and credentials'}
                        />
                        <input
                            type="text"
                            className="personzalization-input"
                            maxLength="40"
                            value={person.embroiderySecondLine}
                            onChange={handleSetPersonField.bind(this, index, 'embroiderySecondLine')}
                            placeholder={'2nd Line: Enter your department'}
                        />
                        <input
                            type="text"
                            className="personzalization-input"
                            maxLength="75"
                            value={person.embroideryEmail}
                            onChange={handleSetPersonField.bind(this, index, 'embroideryEmail')}
                            placeholder={'Email: We will send you a proof to your email'}
                        />
                    </td>
                </tr>);
            }

            let managerRow = null;
            if (props.department != null && props.department.is_for_manager) {
                managerRow = (
                    <tr className="student-row">
                        <td colSpan={personTds.length + 1}>
                            <div className="student-info-container">
                                <div className="input-container">
                                    <input
                                        type="text"
                                        value={person.name}
                                        onChange={handleSetPersonField.bind(this, index, 'name')}
                                        placeholder={'First Name'}
                                    />
                                </div>
                                <div className="input-container">
                                    <input
                                        type="text"
                                        value={person.middleName}
                                        onChange={handleSetPersonField.bind(this, index, 'middleName')}
                                        placeholder={'Middle Name (Optional)'}
                                    />
                                </div>
                                <div className="input-container">
                                    <input
                                        type="text"
                                        value={person.lastName}
                                        onChange={handleSetPersonField.bind(this, index, 'lastName')}
                                        placeholder={'Last Name'}
                                    />
                                </div>
                                <div className="input-container">
                                    <input
                                        type="text"
                                        className="uth-id-field"
                                        value={person.uthId}
                                        onChange={handleSetPersonField.bind(this, index, 'uthId')}
                                        onBlur={handleCheckShirts.bind(this, person.uthId, index)}
                                        placeholder={'UTH-ID#'}
                                    />
                                    <span className="check-shirts-icon" onClick={handleCheckShirts.bind(this, person.uthId, index)}><i className="fas fa-search" /></span>
                                </div>
                            </div>
                        </td>
                    </tr>
                );
            }

            return (
                <Fragment key={index}>
                    <tr>
                        <td colSpan={personTds.length + 1} className="person-row">Person #{(index + 1)}:</td>
                    </tr>
                    {managerRow}
                    <tr className="person-row">
                        {personTds}
                        <td className="delete-icon"><i class="fas fa-trash" onClick={props.removePerson.bind(this, index)} /></td>
                    </tr>
                    {embroideryRow}
                </Fragment>
            );
        });
    };

    const renderSizeChart = () => {
        if (props.apparelItem.size_chart_json == null) {
            return null;
        }

        let line1 = null;
        if (!empty(props.apparelItem.size_chart_line1)) {
            line1 = <div className="size-chart-item">{props.apparelItem.size_chart_line1}</div>;
        }

        let line2 = null;
        if (!empty(props.apparelItem.size_chart_line2)) {
            line2 = <div className="size-chart-item">{props.apparelItem.size_chart_line2}</div>;
        }

        let line3 = null;
        if (!empty(props.apparelItem.size_chart_line3)) {
            line3 = <div className="size-chart-item">{props.apparelItem.size_chart_line3}</div>;
        }

        let line4 = null;
        if (!empty(props.apparelItem.size_chart_line4)) {
            line4 = <div className="size-chart-item">{props.apparelItem.size_chart_line4}</div>;
        }

        let line5 = null;
        if (!empty(props.apparelItem.size_chart_line5)) {
            line5 = <div className="size-chart-item">{props.apparelItem.size_chart_line5}</div>;
        }

        let line6 = null;
        if (!empty(props.apparelItem.size_chart_line6)) {
            line6 = <div className="size-chart-item">{props.apparelItem.size_chart_line6}</div>;
        }

        const sizeChart = JSON.parse(props.apparelItem.size_chart_json);
        return (
            <div className="size-chart">
                <table className="table">
                    {sizeChart.map((row, rowIndex) => {
                        return (
                            <tr>
                                {row.map((column, columnIndex) => {
                                    let classNames = [];
                                    if (rowIndex === 0 || columnIndex === 0) {
                                        classNames.push('text-bold');
                                    }
                                    if (rowIndex === 0) {
                                        classNames.push('th-cell');
                                    }

                                    return <td className={classNames.join(' ')}>{column}</td>
                                })}
                            </tr>
                        );
                    })}
                </table>
                <div className="lines-container">
                    {line1}
                    {line2}
                    {line3}
                    {line4}
                    {line5}
                    {line6}
                </div>
            </div>
        );
    };

    let limitShirtMessage = null;
    if (props.department != null && props.department.is_for_manager) {
        limitShirtMessage = <div className="limit-message">Limited to 5 shirts per employee per year</div>;
    }

    let internationalMessage = null;
    if (props.apparelItem.is_for_international) {
        internationalMessage = <div className="international-message">International District Only</div>;
    }

    let managerForm = null;
    if (props.department != null && props.department.is_for_manager) {
        managerForm = (
            <Fragment>
                <div className="manager-form-container">
                    <h5>Manager Information</h5>
                    <div className="manager-form">
                        <div className="manager-clinic-name">
                            Clinic Name:
                            <select value={props.managerClinicName} onChange={(event) => props.setManagerClinicName(event.target.value)}>
                                <option value="">Select option</option>
                                <option value="Administration">Administration</option>
                                <option value="Cardiothoracic & Vascular Surgery">Cardiothoracic & Vascular Surgery</option>
                                <option value="Dermatology">Dermatology</option>
                                <option value="Family & Community Medicine">Family & Community Medicine</option>
                                <option value="Healthcare Transformation Initiatives">Healthcare Transformation Initiatives</option>
                                <option value="Human Resources">Human Resources</option>
                                <option value="Internal Medicine">Internal Medicine</option>
                                <option value="Obstetrics, Gynecology and Reproductive Sciences">Obstetrics, Gynecology and Reproductive Sciences</option>
                                <option value="Orthopedic Surgery">Orthopedic Surgery</option>
                                <option value="Otorhinolaryngology – Head and Neck Surgery">Otorhinolaryngology – Head and Neck Surgery</option>
                                <option value="Patient Experience">Patient Experience</option>
                                <option value="Pediatric Surgery">Pediatric Surgery</option>
                                <option value="Pediatrics">Pediatrics</option>
                                <option value="Physical Medicine & Rehabilitation">Physical Medicine & Rehabilitation</option>
                                <option value="Psychiatry & Behavioral Sciences">Psychiatry & Behavioral Sciences</option>
                                <option value="Surgery">Surgery</option>
                                <option value="Wellness Services">Wellness Services</option>
                            </select>
                        </div>
                        <div className="manager-name">
                            Manager Name
                            <input
                                type="text"
                                value={props.managerName}
                                onChange={(event) => props.setManagerName(event.target.value)}
                            />
                        </div>
                        <div className="manager-email">
                            Email
                            <input
                                type="text"
                                value={props.managerEmail}
                                onChange={(event) => props.setManagerEmail(event.target.value)}
                            />
                        </div>
                        <div className="manager-address">
                            Address
                            <input
                                type="text"
                                value={props.managerAddress}
                                onChange={(event) => props.setManagerAddress(event.target.value)}
                            />
                        </div>
                        <div className="manager-city">
                            City
                            <input
                                type="text"
                                value={props.managerCity}
                                onChange={(event) => props.setManagerCity(event.target.value)}
                            />
                        </div>
                        <div className="manager-state">
                            State
                            <input
                                type="text"
                                value={props.managerState}
                                onChange={(event) => props.setManagerState(event.target.value)}
                            />
                        </div>
                        <div className="manager-zip">
                            Zip
                            <input
                                type="text"
                                value={props.managerZip}
                                onChange={(event) => props.setManagerZip(event.target.value)}
                            />
                        </div>
                        <div className="manager-phone">
                            Direct Phone Line
                            <input
                                type="text"
                                value={props.managerPhone}
                                onChange={(event) => props.setManagerPhone(event.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }

    let grandTotal = 0;
    for (let i = 0; i < props.persons.length; i++) {
        for (let j = 0; j < props.persons[i].quantities.length; j++) {
            if (parseInt(props.persons[i].quantities[j]) > 0) {
                grandTotal += parseInt(props.persons[i].quantities[j]);
            }
        }
    }

    const handleSetPersonalizationEnabled = (event) => {
        props.setPersonalizationEnabled(event.target.checked)
    };

    let personalizationCheckbox = null;
    if (parseInt(props.apparelItem.logic_version) === 2 && props.apparelItem.allow_personalization) {
        personalizationCheckbox = (
            <div className="customization-checkbox">
                <div>
                    <input
                        type="checkbox"
                        value={props.personalizationEnabled}
                        checked={props.personalizationEnabled}
                        onClick={handleSetPersonalizationEnabled} /> Enable Personalization
                </div>
                <div className="garment-price">$5.00 fee per garment</div>
            </div>
        );
    }

    let inventoryRow = null;
    if (props.apparelItem.is_clearance) {
        inventoryRow = (
            <tr>
                <td>Inventory</td>
                {inventories}
                <td className="delete-icon"></td>
            </tr>
        );
    }
    
    let logoImage = null;
    for (let i = 0; i < props.persons.length; i++) {
        if (props.persons[i].logo !== undefined && logosJson.length > 0) {
            if (parseInt(props.persons[i].logo) === 1) {    // UTP
                logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/utp-logo-140524.png" alt="UTP" className="utp-logo-140524" />
            } else if (parseInt(props.persons[i].logo) === 2) {     // UTH
                if (props.platformType === 'uth') {
                    logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/uth-new-logo.png" alt="UTH" className="uth-logo" />
                } else {
                    logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/uth-new-logo-low.png" alt="UTH" className="uth-utp-logo" />
                }
            } else if (parseInt(props.persons[i].logo) === 3) {     // UTH Houston
                logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/uth-houston-logo.png" alt="UTH Houston" className="uth-houston-logo" />
            } else if (parseInt(props.persons[i].logo) === 4) {     // Cizik School of Nursing
                logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/uth-cizik.logo.png" alt="Cizik School of Nursing" className="uth-cizik-logo" />
            } else if (parseInt(props.persons[i].logo) === 5) {     // McGovern Medical School
                logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/uth-mcgovern-logo.png" alt="McGovern Medical School" className="uth-mcgovern-logo" />
            } else if (parseInt(props.persons[i].logo) === 6) {     // School of Biomedical Informatics
                logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/uth-biomedical-informatics-logo.png" alt="School of Biomedical Informatics" className="uth-biomedical-informatics-logo" />
            } else if (parseInt(props.persons[i].logo) === 7) {     // School of Dentistry
                logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/uth-dentistry-logo.png" alt="School of Dentistry" className="uth-dentistry-logo" />
            } else if (parseInt(props.persons[i].logo) === 8) {     // School of Public Health
                logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/uth-public-health-logo.png" alt="School of Public Health" className="uth-public-health-logo" />
            } else if (parseInt(props.persons[i].logo) === 9) {     // UTHealth Houston General
                logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/uth-general-logo.png" alt="UTHealth Houston General" className="uth-general-logo" />
            } else if (parseInt(props.persons[i].logo) === 10) {     // School of Public Health - Austin
                logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-austin.png" alt="School of Public Health - Austin" className="uth-public-health-austin-logo" />
            } else if (parseInt(props.persons[i].logo) === 11) {     // School of Public Health - Brownsville
                logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-brownsville.png" alt="School of Public Health - Brownsville" className="uth-public-health-brownsville-logo" />
            } else if (parseInt(props.persons[i].logo) === 12) {     // School of Public Health - Dallas
                logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-dallas.png" alt="School of Public Health - Dallas" className="uth-public-health-dallas-logo" />
            } else if (parseInt(props.persons[i].logo) === 13) {     // School of Public Health - El Paso
                logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-el-paso.png" alt="School of Public Health - El Paso" className="uth-public-health-el-paso-logo" />
            } else if (parseInt(props.persons[i].logo) === 14) {     // School of Public Health - San Antonio
                logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/school-of-public-health-san-antonio.png" alt="School of Public Health - San Antonio" className="uth-public-health-san-antonio-logo" />
            } else if (parseInt(props.persons[i].logo) === 15) {     // UTHealth Houston Children's Heart Institute
                logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/uth-childrens-heart.png" alt="UTHealth Houston Children's Heart Institute" className="uth-childrens-heart" />
            } else if (parseInt(props.persons[i].logo) === 16) {     // McWilliams School of Biomedical Informatics
                logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/mcwilliams-logo-v82923.png" alt="McWilliams School of Biomedical Informatics" className="uth-childrens-heart" />
            } else if (parseInt(props.persons[i].logo) === 17) {     // UTHealth Houston Neurosciences
                logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/UTHH-Neuroscience.png" alt="UTHealth Houston Neurosciences" className="uth-childrens-heart" />
            } else if (parseInt(props.persons[i].logo) === 18) {     // UTHealth Houston Cizik Eye Clinic
                logoImage = <img src="https://ac-ut-health.s3.amazonaws.com/css/UTHH-RobertCizikEyeClinic.png" alt="UTHealth Houston Cizik Eye Clinic" className="uth-childrens-heart" />
            }

            break;
        }
    }

    let favoriteClasses = ['favorite-container'];
    let favoriteIcon = <i className="far fa-heart empty-heart" />;
    if (props.isFavorite) {
        favoriteClasses.push('active');
        favoriteIcon = <i className="fas fa-heart filled-heart" />
    }

    const handleAddFavorite = () => {
        props.addFavorite(props.history);
    };

    let shoppingCartButton = <div><button type="button" className="continue" onClick={continueHandler.bind(this, 1)} disabled={props.addingToCart}>{buttonLabel}</button></div>;
    if (props.action === 'edit') {
        shoppingCartButton = null;
    }

    let onHandTitle = 'On-Hand';
    let wareHouseRow = (
        <tr>
            <th>Warehouse</th>
            {headers}
            {logosJson.length > 0 ? <th className="text-center">Select Logo</th> : null}
            <th className="delete-icon"></th>
        </tr>
    );

    if (props.platformType === 'uth') {
        onHandTitle = 'Select Logo';
        wareHouseRow = null;
    }

    return (
        <div className="form-container">
            {managerForm}
            <h5>Make your selection</h5>
            <div className={favoriteClasses.join(' ')} onClick={handleAddFavorite}>
                {favoriteIcon} Favorites
            </div>
            <table className="pricing-table table">
                <thead>
                    <tr>
                        <th>Pricing</th>
                        {headers}
                        {logosJson.length > 0 ? <th className="text-center">{onHandTitle}</th> : null}
                        <th className="delete-icon"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Price</td>
                        {prices}
                        <td className="delete-icon"></td>
                    </tr>
                    {inventoryRow}
                    {wareHouseRow}
                    {renderPersons()}
                    <tr>
                        <th>Total</th>
                        {totalsColumns}
                        {logosJson.length > 0 ? <th></th> : null}
                        <th className="delete-icon"></th>
                    </tr>
                </tbody>
            </table>
            <div className="add-person-button-container">
                <div className="add-person-button" onClick={handleAddPerson}>
                    <i class="fas fa-plus" /> Add a person
                </div>
            </div>
            <div className="grand-total">Total Items: <span>{grandTotal}</span></div>
            {personalizationCheckbox}
            <div className="text-center">
                <div><button type="button" className="continue" onClick={continueHandler.bind(this, 2)} disabled={props.savingWork}>{saveWorkLabel}</button></div>
                {shoppingCartButton}
            </div>
            {internationalMessage}
            {limitShirtMessage}
            {renderSizeChart()}
            <div className="logo-image">
                {logoImage}
            </div>
            <div className="notice">
                All apparel orders are non-returnable. If you would like to schedule a fitting, please send us a message through the Help Desk link so we can contact you.
            </div>
            <div className="text-center">
                <button className="help-desk-button" onClick={props.showHelpModal}>Help Desk</button>
            </div>
        </div>
    );
});

export default Form;
